import React from 'react';

export function DeniedDot() {
  return <div className="my-auto h-4 w-4 rounded-full bg-red-500"></div>;
}
